import React from 'react'

import Sticker from 'react-stickyfill'
import { Waypoint } from 'react-waypoint'
import ReactPlayer from 'react-player'

import SoundButton from './soundButton'
import PlayButton from './playButton'

import videoStyles from './videoFullscreen.module.scss'

class VideoFullscreen extends React.Component {
  constructor(props) {
    super(props)
    this.updateTimeElapsed = this.updateTimeElapsed.bind(this)
    this.playVideo = this.playVideo.bind(this)
    this.pauseVideo = this.pauseVideo.bind(this)
    this.setMute = this.setMute.bind(this)
    this.state = {
      paused: true,
      player: null,
      videoProgress: 0,
      muted: true,
    }
  }

  updateTimeElapsed(e) {
    this.setState({
      videoProgress: e.played,
    })
  }

  playVideo() {
    if (this.state.player) {
      this.state.player.playVideo()
      // this.setState({
      //   paused: false,
      // })
    }
  }

  pauseVideo() {
    if (this.state.player) {
      this.state.player.pauseVideo()
      // this.setState({
      //   paused: true,
      // })
    }
  }

  setMute(muted) {
    this.setState({ muted })
    if (muted) {
      this.state.player.mute()
    } else {
      this.state.player.unMute()
    }
    // console.log(this.state)
  }

  render() {
    const { block, changeHeaderVisibility } = this.props

    return (
      <section className={videoStyles.section}>
        <Sticker>
          <Waypoint
            onEnter={() => {
              this.playVideo()
              changeHeaderVisibility(false)
            }}
            onLeave={() => {
              this.pauseVideo()
              changeHeaderVisibility(true)
            }}
            topOffset="20%"
            bottomOffset="20%"
          >
            <div className={`clearfix ${videoStyles.spacer}`}>
              {/* PROGRESS INDICATOR */}
              <header className={videoStyles.header}>
                <div className={videoStyles.timetotal}>
                  <span
                    className={videoStyles.timeElapsed}
                    style={{ transform: `scaleX(${this.state.videoProgress})` }}
                  ></span>
                </div>
              </header>
              {/* EMBED */}
              <ReactPlayer
                className={`${this.state.paused ? videoStyles.paused : ''} ${
                  videoStyles.player
                }`}
                url={`https://www.youtube.com/watch?v=${block.youtube_id}`}
                onReady={e => {
                  const player = e.player.player.player
                  this.setState({
                    player,
                    muted: player.isMuted(),
                    iframe: player.getIframe(),
                  })
                  player.getIframe().tabIndex = -1
                  this.state.player.pauseVideo()
                }}
                onPlay={() => {
                  this.setState({ paused: false })
                }}
                onPause={() => {
                  this.setState({ paused: true })
                }}
                progressInterval={15}
                onProgress={this.updateTimeElapsed}
                loop={true}
                height="100vh"
                width="100vw"
              />
              {/* VIDEO CONTROLS */}
              <footer className={videoStyles.footer}>
                <SoundButton
                  className={videoStyles.soundButton}
                  muted={this.state.muted}
                  videoReady={this.state.videoProgress > 0}
                  onClick={() => {
                    this.setMute(!this.state.muted)
                  }}
                />
                <PlayButton
                  className={videoStyles.playButton}
                  paused={this.state.paused}
                  videoReady={this.state.videoProgress > 0}
                  onClick={() => {
                    if (this.state.player.getPlayerState() === 1) {
                      this.pauseVideo()
                    } else {
                      this.playVideo()
                    }
                  }}
                />
              </footer>
            </div>
          </Waypoint>
        </Sticker>
      </section>
    )
  }
  componentDidMount() {
    this.setState({ value: 0 })
  }
}

export default VideoFullscreen
